module.exports = __webpack_public_path__ + "static/media/SF-10-A (1).f3aa6a8e.mp3";